// src/api/queryClient.ts
/**
 * Centralised React‑Query QueryClient instance.
 * It is imported by all hooks so that they share the same cache, retry
 * strategy and stale‑time configuration.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes – adjust per endpoint if needed
      staleTime: 5 * 60 * 1000,
      // Retry failed queries up to 2 times (exponential back‑off)
      retry: 2,
      // Cache results for 30 minutes unless garbage‑collected earlier
      cacheTime: 30 * 60 * 1000,
      // Do not refetch on window focus for background tabs
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Mutations are not retried by default – let the UI decide
      retry: false,
    },
  },
});
